import { ComponentsPathItemsElement } from '@swagger-api/apidom-ns-openapi-3-1';

/**
 * @public
 */
class ComponentsPathItems extends ComponentsPathItemsElement {
  // OpenAPI 3.2 does not introduce changes to ComponentsPathItems.
  // This class inherits all functionality from OpenAPI 3.1.
}
export default ComponentsPathItems;